import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Col, FormGroup, InputGroup, Row } from "reactstrap";
import { AvField } from "availity-reactstrap-validation";
import CustomMultipleDateRange from "../../../../../components/CustomMultipleDateRange/CustomMultipleDateRange";

const CustomPlanItem = ({ num, keys, onDelete, items }) => {
  return (
    <StyledRow className="justify-content-between fade-in-custom-animate-1s">
      <AvField
        name={`id|${keys}`}
        placeholder="id"
        value={items.id || ""}
        type="number"
        className="form-control d-none"
      />
      <AvField
        name={`cashback_id|${keys}`}
        placeholder="cashback_id"
        value={items.cashback_id || ""}
        type="number"
        className="form-control d-none"
      />
      <Col sm={3}>
        <PickerStyled>
          <label htmlFor="">Date:</label>
          <FormGroup className="mb-3">
            <CustomMultipleDateRange
              placeholder="Select date..."
              name={`date|${keys}`}
              name_id={`date-for-plans-${keys}-data`}
              defaultValue={items.date || ""}
              datePickerType={"calendar"}
              // defaultValue={data?.contract_signatured_date || ""}
              // onChange={date => (selectedDate.from = date)}
              errorText="Date from is required!"
              required
            />
          </FormGroup>
        </PickerStyled>
      </Col>
      <Col sm={3} className="mt-1 mb-1">
        <label htmlFor="">Income:</label>
        <AvField
          name={`payment|${keys}`}
          placeholder="Income..."
          type="number"
          className="form-control"
          value={items.payment || ""}
          validate={{
            required: {
              value: true,
              errorMessage: "Please, enter a income",
            },
          }}
        />
      </Col>
      <Col sm={3} className="mt-1 mb-1">
        <label htmlFor="">Cost:</label>
        <AvField
          name={`spend|${keys}`}
          placeholder="Cost..."
          type="number"
          className="form-control"
          value={items.spend || ""}
          validate={{
            required: {
              value: true,
              errorMessage: "Please, enter a cost",
            },
          }}
        />
      </Col>
      <Col sm={3} className="mt-1 mb-1">
        <label htmlFor="">Cashback:</label>
        <AvField
          name={`cashback|${keys}`}
          placeholder="Cashback..."
          type="number"
          className="form-control"
          value={items.cashback || ""}
          validate={{
            required: {
              value: true,
              errorMessage: "Please, enter a cashback",
            },
          }}
        />
      </Col>
      <div className="delete-button--plan">
        <button
          type="button"
          className="btn btn-danger btn-sm delete-button--btn"
          onClick={onDelete}
        >
          <i className="mdi mdi-trash-can d-block font-size-8" />
        </button>
      </div>
    </StyledRow>
  );
};

const PickerStyled = styled(InputGroup)`
  flex-direction: column;
  margin-top: 4px;

  p {
    margin-bottom: 6px;
  }

  input {
    width: 100% !important;
    min-width: 40px !important;
    height: 38px;
    font-size: 12px;
    background: #fff !important;
  }
`;

const StyledRow = styled(Row)`
  position: relative;
  margin: 0;
  margin-bottom: 10px;
  padding: 20px;
  border: 1px solid #dcdde2;
  box-sizing: border-box;
  border-radius: 3px;

  .delete-button--plan {
    .delete-button--btn {
      position: absolute;
      top: -96px;
      right: -10px;
    }
  }
`;

CustomPlanItem.propTypes = {
  keys: PropTypes.string.isRequired,
  num: PropTypes.number.isRequired,
  onDelete: PropTypes.func,
  items: PropTypes.object,
};

export default CustomPlanItem;
